import { render, staticRenderFns } from "./SelectedRiskAssign.vue?vue&type=template&id=304db28a&"
import script from "./SelectedRiskAssign.vue?vue&type=script&lang=ts&"
export * from "./SelectedRiskAssign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports